
















































import Vue from 'vue'
import store from '@/store'
import actions from '@/actions'
import { ImageFile } from '../types'

export default Vue.extend({
  name: 'SignupInsirationPhotos',

  data: () => ({
    imageObjectUrls: {} as { [key: string]: string },
    store,
    unsavedImages: [] as Array<string>,
  }),

  computed: {
    hasUploadedFiles(): boolean {
      return this.store.state.inspirationFilesArePersisted
    },
    imageFiles(): Array<ImageFile> {
      return this.store.state.inspirationFiles
    },
    signupKey() {
      return this.store.state.signupType.key
    },
    stepCount(): string {
      return this.store.getCurrentStepCount(
        this.signupKey,
        String(this.$route.name),
      )
    },
  },

  methods: {
    confirmDeleteImage(image: ImageFile) {
      // eslint-disable-next-line no-restricted-globals
      if (confirm(`Are you sure you want to delete image '${image.filename}'?`)) { // eslint-disable-line no-alert
        this.deleteImage(image)
      }
    },

    deleteImage(image: ImageFile): void {
      actions.deleteInspirationImage(this.store.state.signupId, image)
    },

    goBack() {
      const prevStep = this.store.getPreviousStep(
        this.signupKey,
        String(this.$route.name),
      )
      if (prevStep) {
        this.$router.push({ name: prevStep.routeName })
      }
    },

    goForward() {
      const nextStep = this.store.getNextStep(
        this.signupKey,
        String(this.$route.name),
      )
      if (nextStep) {
        this.$router.push({ name: nextStep.routeName })
      }
    },

    handleFileChange() {
      const input = document.querySelector('#inspirationRoom') as HTMLInputElement

      if (input && input.files) {
        this.unsavedImages = Array.from(input.files).map(f => URL.createObjectURL(f))
      }
    },

    srcFor(image: ImageFile): string | null {
      return this.imageObjectUrls[image.filename]
    },

    async submit(e: Event) {
      e.preventDefault()
      if (this.store.state.isBusy) return

      const input = document.querySelector('#inspirationRoom') as HTMLInputElement
      if (input && input.files && input.files.length > 0) {
        store.setIsBusy(true)
        const formData = new FormData()
        Array.from(input.files).forEach(file => {
          formData.append('signupFiles', file);
        })
        try {
          await actions.saveInspirationFiles(formData)
          this.goForward()
        } catch (err) {
          this.store.setErrorMessage('Could not upload images')
        } finally {
          store.setIsBusy(false)
        }
      } else {
        this.goForward()
      }
    },
  },

  async mounted() {
    if (this.hasUploadedFiles) {
      this.imageObjectUrls = await actions.fetchSignupImages(this.store.state.inspirationFiles)
    }
  },
})
